import { css, useTheme } from 'styled-components';

import { FONT_BRIGHTNESS } from '@hivebrite/design-system/Theme';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

// Frame (Card & equivalent) can be customize by the Admin in the BO
const useFrameTheme = ({ network } = {}) => {
  const { currentNetwork } = useDefaultAppContexts();
  const theme = useTheme();

  const networkData = network || currentNetwork;

  if (theme?.themeName === 'bo') {
    return {
      backgroundColor: '#FFFFFF',
      fontBrightness: FONT_BRIGHTNESS.DARK,
      borderRadius: 10,
      dropShadow: 'rgba(0, 0, 0, 0.1)',
      boxShadow: css`
        box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
      `,
      themeName: 'bo',
    };
  }

  return {
    backgroundColor: networkData?.theming?.fo?.fo_frame_background_color,
    fontBrightness: networkData?.theming?.fo?.fo_frame_font_brightness,
    borderRadius: networkData?.theming?.fo?.fo_frame_border_radius,
    dropShadow: networkData?.theming?.fo?.fo_frame_drop_shadow,
    boxShadow: css`
      box-shadow: 0 1px 6px 0 ${networkData?.theming?.fo?.fo_frame_drop_shadow};
    `,
    themeName: 'fo',
  };
};

export default useFrameTheme;
